type TRedirectStatic = {
    type: 'static',
    from: string | RegExp,
    to: string,
};

type TRedirectDynamic = {
    type: 'dynamic',
    from: RegExp,
    to: (dynamicPart: string) => string,
};

export type TRedirect = TRedirectStatic | TRedirectDynamic;

export const redirectByAuth: Record<'forAuthorized' | 'forUnauthorized', TRedirectStatic[]> = {
    forAuthorized: [
        { type: 'static', from: '/', to: '/lk' },
        { type: 'static', from: '/user/login', to: '/lk' },
        { type: 'static', from:  '/bundles', to: '/lk/change-tariff' },
        { type: 'static', from:  new RegExp(/\/bundles\/(.+)/), to: '/lk/change-tariff' },
        { type: 'static', from:  '/user/change-agreement', to: '/lk/user/change-agreement' },
    ],
    forUnauthorized: [
        { type: 'static', from: '/lk/aboutdomrubonus', to: '/' },
        { type: 'static', from: '/lk/management/cancellation', to: '/lk/management' },
        { type: 'static', from: '/lk/settings/phone', to: '/' },
        { type: 'static', from: '/movix-pro', to: '/movix-new' },
        { type: 'static', from: '/domru-tv', to: '/movix-new' },
        { type: 'static', from:  new RegExp(/\/bundles\/(?!village)(.+)/), to: '/full-buy?tariffName=$1&monoTariff=false' },
        { type: 'static', from:  new RegExp(/\/bundles\/village(.+)/), to: '/internet/mono-village' },
        { type: 'static', from:  '/user/change-agreement', to: '/lk/user/change-agreement' },
    ],
};

const mskTariffsRoute = '/landing-promo/msk-tariffs';

export const redirectOnMsk: TRedirectStatic[] = [
    { type: 'static', from: new RegExp(/^\/(bundles|request)[^\s]*/), to: mskTariffsRoute },
    { type: 'static', from: new RegExp(/^\/internet((?!(equipment|yandex|wifi)).)*$/), to: mskTariffsRoute },
    { type: 'static', from: '/online-buy', to: mskTariffsRoute },
];

/**
 * ⚠️ Для rewrite все static файлы должны лежать в директории /static/core, чтобы NextJS мог их зарезолвить.
 */
export const rewrite: TRedirect[] = [
    // seo system files
    { type: 'static', from: '/robots.txt', to: '/api/robots.txt' },
    { type: 'static', from: '/9b25e45be0034d37876303e323bd7026.txt', to: '/api/indexNow.txt' },
    // static files
    { type: 'static', from: '/favicon.ico', to: '/static/core/favicon.ico' },
    { type: 'static', from: '/icon.svg', to: '/static/core/icon.svg' },
    { type: 'static', from: '/apple-touch-icon.png', to: '/static/core/apple-touch-icon.png' },
    { type: 'static', from: '/android-chrome-192x192.png', to: '/static/core/android-chrome-192x192.png' },
    { type: 'static', from: '/android-chrome-512x512.png', to: '/static/core/android-chrome-512x512.png' },
    { type: 'static', from: '/domru.webmanifest', to: '/static/core/domru.webmanifest' },
    // old domru static
    { type: 'static', from: '/policy.pdf', to: '/static/core/policy.pdf' },
    { type: 'static', from: new RegExp(/\/images\/(.+)/), to: '/static/core/domru-images/$1' },
    // iOS deeplinks
    { type: 'static', from: '/.well-known/apple-app-site-association', to: '/api/apple-app-site-association' },
    // Android deeplinks
    { type: 'static', from: '/.well-known/assetlinks.json', to: '/static/core/assetlinks.json' },
    // old faq articles /service/knowledgebase/[categorySlug]/[articleSlug]
    { type: 'static', from: new RegExp(/\/service\/knowledgebase\/(.+)/), to: '/api/faq-redirects' },
    // PWA
    { type: 'static', from: '/sw.js', to: '/static/core/sw.js' },
    {
        type: 'dynamic',
        from: /\/workbox-(.+)\.js/,
        to: (dynamicPart) => `/static/core/workbox-${dynamicPart}.js`,
    },
];

export const referrersWhiteList = [
    'dom.ru',
    'domru.ru',
    'r-one.io',
    'ertelecom.ru',
    'movix.ru',
];

export const withoutMiddlewaresList = [
    '/_next/static',
    '/_next/data',
    '/static',
    '/payments-response',
    '/api/lesta',
    '/api/csrf',
    '/api/yandex/oauth',
    '/api/metrics',
    '/chat',
];
